import { render, staticRenderFns } from "./wxPay.vue?vue&type=template&id=af02a64c&scoped=true&"
import script from "./wxPay.vue?vue&type=script&lang=js&"
export * from "./wxPay.vue?vue&type=script&lang=js&"
import style0 from "./wxPay.vue?vue&type=style&index=0&id=af02a64c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af02a64c",
  null
  
)

export default component.exports